module.exports = __webpack_public_path__ + "static/img/1.a788c1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/zh/1.png
// module id = 8f8E
// module chunks = 0